import * as React from "react";

function SvgLoadPort(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 56 56" fill="none" {...props}>
      <path
        d="M13 19.818v4.091H43v-4.09H13zM18.454 34.818L28 25.273l9.545 9.545h-6.818V43h-5.454v-8.182h-6.819zM14.364 18.454h27.272L36.182 13H19.818l-5.454 5.454z"
        fill="#fff"
      />
      <circle cx={28} cy={28} r={27} stroke="#fff" />
    </svg>
  );
}

export default SvgLoadPort;
